import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Row, Button, FormControl } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import '../style.css'

import { getPublicationsWithFilters, changePublicationsFilter, clearAllPublicationFilters, changePublicationsPage, changePublicationApprovalStatusSortType } from '../reducers/managePublications'

import NewPublication from './NewPublication'
import ExportPublications from './ExportPublications'
import ExportPublicationCitations from './ExportPublicationCitations'

class PublicationFilter extends Component {

  state = {
    showNewPublicationForm: false,
  }

  componentDidUpdate(prevProps) {
    if (this.publicationsShouldBeRefetched(prevProps)) {
      this.applyFilters()
    }
  }

  toggleShowNewPublicationForm = () => {
    this.setState({ showNewPublicationForm: !this.state.showNewPublicationForm})
  }

  publicationsShouldBeRefetched = (prevProps) => {
    const {
      publicationsSearchTerm,
      publicationsYearFilter,
      publicationsAuthorFilter,
      publicationsSortType,
      publicationsClientFilter,
      publicationsProductFilter,
      publicationsIndicationFilter,
      publicationsTherapeuticAreasFilter,
      publicationsStudyDesignsFilter,
      publicationsDataSourcesFilter,
      publicationsDataSourceTypesFilter,
      publicationsMethodAnalysisTypesFilter,
      publicationsPublicationTypeFilter,
      publicationsDoneWithGenesis,
      publicationsRegulatoryRelated,
      publicationsApprovalStatusFilter,
      publicationsApprovalStatusSortType,
      // publicationsTherapeuticAreaFilter,
      // publicationsAnalysisTypeFilter,
      // publicationsDatabaseFilter,
    } = this.props

    if ((prevProps.publicationsSortType !== publicationsSortType) || (prevProps.publicationsApprovalStatusSortType !== publicationsApprovalStatusSortType)) {
      return true
    }

    if ((prevProps.publicationsAuthorFilter && (prevProps.publicationsAuthorFilter.length !== publicationsAuthorFilter.length)) ||
        (prevProps.publicationsClientFilter && (prevProps.publicationsClientFilter.length !== publicationsClientFilter.length)) ||
        (prevProps.publicationsProductFilter && (prevProps.publicationsProductFilter.length !== publicationsProductFilter.length)) ||
        (prevProps.publicationsIndicationFilter && (prevProps.publicationsIndicationFilter.length !== publicationsIndicationFilter.length)) ||
        (prevProps.publicationsTherapeuticAreasFilter && (prevProps.publicationsTherapeuticAreasFilter.length !== publicationsTherapeuticAreasFilter.length)) ||
        (prevProps.publicationsStudyDesignsFilter && (prevProps.publicationsStudyDesignsFilter.length !== publicationsStudyDesignsFilter.length)) ||
        (prevProps.publicationsDataSourcesFilter && (prevProps.publicationsDataSourcesFilter.length !== publicationsDataSourcesFilter.length)) ||
        (prevProps.publicationsDataSourceTypesFilter && (prevProps.publicationsDataSourceTypesFilter.length !== publicationsDataSourceTypesFilter.length)) ||
        (prevProps.publicationsMethodAnalysisTypesFilter && (prevProps.publicationsMethodAnalysisTypesFilter.length !== publicationsMethodAnalysisTypesFilter.length)) ||
        (prevProps.publicationsPublicationTypeFilter && (prevProps.publicationsPublicationTypeFilter.length !== publicationsPublicationTypeFilter.length)) ||
        (prevProps.publicationsYearFilter && (prevProps.publicationsYearFilter.length !== publicationsYearFilter.length)) ||
        (prevProps.publicationsDoneWithGenesis !== publicationsDoneWithGenesis) ||
        (prevProps.publicationsRegulatoryRelated !== publicationsRegulatoryRelated) ||
        (prevProps.publicationsApprovalStatusFilter && (prevProps.publicationsApprovalStatusFilter.length !== publicationsApprovalStatusFilter.length)))
        // (prevProps.publicationsTherapeuticAreaFilter.length !== publicationsTherapeuticAreaFilter.length) || 
        // (prevProps.publicationsAnalysisTypeFilter.length !== publicationsAnalysisTypeFilter.length) || 
        // (prevProps.publicationsDatabaseFilter.length !== publicationsDatabaseFilter.length) ||
        {
      return true
    }

    if ( (prevProps.publicationsSearchTerm && !publicationsSearchTerm)) {
      return true
    }

    return false
  }

  handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      this.applyFilters()
    }
  }

  applyFilters = () => {
    this.props.changePublicationsPage(1)
    this.props.getPublicationsWithFilters(1, this.props)
  }

  handleChangeFilters = (filterType, filters) => {
    this.props.changePublicationsFilter(filterType, filters)
  }

  render() {
    const { showNewPublicationForm } = this.state

    const {
      genesisUsers,
      therapeuticAreas,
      studyDesigns,
      dataSources,
      dataSourceTypes,
      methodAnalysisTypes,
      publicationTypes,
      publicationsYearFilter,
      publicationsAuthorFilter,
      publicationsClientFilter,
      publicationsProductFilter,
      publicationsIndicationFilter,
      publicationsTherapeuticAreasFilter,
      publicationsStudyDesignsFilter,
      publicationsDataSourcesFilter,
      publicationsDataSourceTypesFilter,
      publicationsMethodAnalysisTypesFilter,
      publicationsPublicationTypeFilter,
      publicationsDoneWithGenesis,
      publicationsRegulatoryRelated,
      publicationsSortType,
      totalPublicationCount,
      filteredPublicationCount,
      metadata,
      publicationsApprovalStatusFilter,
      // publicationsTherapeuticAreaFilter,
      // publicationsAnalysisTypeFilter,
      // publicationsDatabaseFilter,
    } = this.props
    
    return (
      <Fragment>

        <NewPublication
          show={showNewPublicationForm}
          toggleShow={this.toggleShowNewPublicationForm}
          history={this.props.history}
        />

        <div style={{marginBottom: '25px'}}>
          <Row className="activity-tracker">
            <center>
              <span style={{textDecoration: 'underline'}}>
                Publications
              </span>
              <br/>
              <span>
                Total: {totalPublicationCount}
              </span>
              <br/>
              <span>
                Filtered: {filteredPublicationCount}
              </span>
            </center>
          </Row>
            <Row>
              <center>
                <div style={{margin:"15px auto 0 auto"}}>
                  <div style={{display:"inline-block"}}>
                    <Button disabled>
                      New Publication
                    </Button>
                  </div>
                </div>
              </center>
            </Row>
            <Row>
              <center>
                <div style={{margin:"10px auto 0 auto", padding:"10px 14px", backgroundColor:"#fff3cd", border:"1px solid #ffc107", borderRadius:"4px", color:"#856404"}}>
                  <span>Please enter all new publications in{' '}
                    {!["DEV", "STAGING"].includes(process.env.REACT_APP_MODE) ? (
                      <a href="https://genesisrg.sharepoint.com/sites/ValueandSciComsHub/Lists/Pub%20Hub%20%20every%20publication%20manuscript%20poster%20abstract%20and%20more%20authored%20by%20our%20organization/AllItems.aspx" target="_blank" rel="noopener noreferrer" style={{color:"#0056b3", fontWeight:"bold"}}>
                        PubHub
                      </a>
                    ) : (
                      <span style={{color:"#0056b3", fontWeight:"bold"}}>PubHub</span>
                    )}
                    {' '}instead.
                  </span>
                </div>
              </center>
            </Row>
        </div>
        <hr/>

        <center>
          <h3>Sort by</h3>
        </center>
        <div>
          {/* <h5>Sort Publications By</h5> */}
          <FormControl
            componentClass="select"
            placeholder="Sort Publications"
            onChange={(e) => this.props.changePublicationsFilter("publicationsSortType", e.target.value)}
            value={publicationsSortType}
          >
            <option value="-year">Year (Descending)</option>
            <option value="year">Year (Ascending)</option>
            <option value="citation">Citation</option>
            <option value="journal_conference">Journal/Conference</option>
          </FormControl>
          {this.props.publicationManagementMode ?
            <div>
              <h5>Sort by Approval Status</h5>
              <FormControl
                componentClass="select"
                placeholder="Sort By Approval Status"
                onChange={(e) => this.props.changePublicationApprovalStatusSortType(e.target.value)}
                value={this.props.publicationsApprovalStatusSortType}
              >
                <option value="none">None</option>
                <option value="-is_approved">Approval Status (Descending)</option>
                <option value="is_approved">Approval Status (Ascending)</option>
              </FormControl>
            </div>
            :
            null
          }
        </div>

        <center>
          <h3>Filter by</h3>
        </center>

        {/* <center>
          <ButtonGroup className="my-project-filter-buttons">
            <Button onClick={this.applyFilters}>
              Apply Filters
            </Button>
            <Button onClick={this.props.clearAllPublicationFilters}>
              Clear All Filters
            </Button>
          </ButtonGroup>
        </center> */}

        {this.props.publicationManagementMode ?
          <div>
            <h5>Aproval Status</h5>
              <Typeahead
                id="ApprovalStatusFilterTypeahead"
                clearButton
                // labelKey={(author) => `${author.first_name} ${author.last_name}`}
                multiple
                selected={publicationsApprovalStatusFilter}
                options={["Approved", "Awaiting Approval", "Incomplete"]}
                placeholder="Select Approval Statuses"
                onChange={(statuses) => this.handleChangeFilters('publicationsApprovalStatusFilter', statuses)}
              />
          </div>
          :
          null
        }

        <div>
          <h5>Genesis Author(s)</h5>
          <Typeahead
            id="AuthorFilterTypeahead"
            clearButton
            labelKey={(author) => `${author.first_name} ${author.last_name}`}
            multiple
            selected={publicationsAuthorFilter}
            options={ genesisUsers || []}
            placeholder="Enter Genesis author(s)"
            onChange={(users) => this.handleChangeFilters('publicationsAuthorFilter', users)}
          />
        </div>
        <div>
          <h5>Year</h5>
          <Typeahead
            id="YearFilterTypeahead"
            clearButton
            multiple
            selected={ publicationsYearFilter }
            options={ metadata.year || [] }
            placeholder="Enter Year(s)"
            onChange={(years) => this.handleChangeFilters('publicationsYearFilter', years)}
          />
        </div>
        <div>
          <h5>Client</h5>
          <Typeahead
            id="ClientFilterTypeahead"
            clearButton
            multiple
            selected={ publicationsClientFilter }
            options={ metadata.publication_client || [] }
            placeholder="Enter Clients(s)"
            onChange={(clients) => this.handleChangeFilters('publicationsClientFilter', clients)}
          />
        </div>
        <div>
          <h5>Product</h5>
          <Typeahead
            id="ProductFilterTypeahead"
            clearButton
            multiple
            selected={ publicationsProductFilter }
            options={ metadata.product || [] }
            placeholder="Enter Product(s)"
            onChange={(products) => this.handleChangeFilters('publicationsProductFilter', products)}
          />
        </div>
        <div>
          <h5>Indication</h5>
          <Typeahead
            id="IndicationFilterTypeahead"
            clearButton
            multiple
            selected={ publicationsIndicationFilter }
            options={ metadata.indication || [] }
            placeholder="Enter Indication(s)"
            onChange={(users) => this.handleChangeFilters('publicationsIndicationFilter', users)}
          />
        </div>
        {/* <div>
          <h5>Therapeutic Area</h5>
          <Typeahead
            id="TherapeuticAreaFilterTypeahead"
            clearButton
            multiple
            selected={ publicationsTherapeuticAreaFilter }
            options={ metadata.therapeutic_area || [] }
            placeholder="Enter Therapeutic Area(s)"
            onChange={(therapeuticAreas) => this.handleChangeFilters('publicationsTherapeuticAreaFilter', therapeuticAreas)}
          />
        </div> */}
        <div>
        </div><div>
          <h5>Therapeutic Area(s)</h5>
          <Typeahead
            id="TherapeuticAreasFilterTypeahead"
            clearButton
            labelKey={(therapeuticArea) => `${therapeuticArea.name}`}
            multiple
            selected={publicationsTherapeuticAreasFilter}
            options={therapeuticAreas || []}
            placeholder="Enter Therapeutic Area(s)"
            onChange={(therapeuticAreas) => this.handleChangeFilters('publicationsTherapeuticAreasFilter', therapeuticAreas)}
          />
        </div><div>
        </div><div>
          <h5>Study Design(s)</h5>
          <Typeahead
            id="StudyDesignsFilterTypeahead"
            clearButton
            labelKey={(studyDesign) => `${studyDesign.name}`}
            multiple
            selected={publicationsStudyDesignsFilter}
            options={studyDesigns || []}
            placeholder="Enter Study Design(s)"
            onChange={(studyDesigns) => this.handleChangeFilters('publicationsStudyDesignsFilter', studyDesigns)}
          />
        </div><div>
          <h5>Publication Type</h5>
          <Typeahead
            id="PublicationTypeFilterTypeahead"
            clearButton
            labelKey={(publicationType) => `${publicationType.name}`}
            multiple
            selected={publicationsPublicationTypeFilter}
            options={publicationTypes || []}
            placeholder="Enter Publication Type(s)"
            onChange={(publicationTypes) => this.handleChangeFilters('publicationsPublicationTypeFilter', publicationTypes)}
          />
        </div>
        {/* <div>
          <h5>Analysis Type</h5>
          <Typeahead
            id="AnalysisTypeFilterTypeahead"
            clearButton
            multiple
            selected={ publicationsAnalysisTypeFilter }
            options={ metadata.analysis_type || [] }
            placeholder="Enter Analysis Type(s)"
            onChange={(analysisTypes) => this.handleChangeFilters('publicationsAnalysisTypeFilter', analysisTypes)}
          />
        </div> */}
        <div>
          <h5>Method / Analysis Type(s)</h5>
          <Typeahead
            id="MethodAnalysisTypesFilterTypeahead"
            clearButton
            labelKey={(methodAnalysisType) => `${methodAnalysisType.name}`}
            multiple
            selected={publicationsMethodAnalysisTypesFilter}
            options={methodAnalysisTypes || []}
            placeholder="Enter Method / Analysis Type(s)"
            onChange={(methodAnalysisTypes) => this.handleChangeFilters('publicationsMethodAnalysisTypesFilter', methodAnalysisTypes)}
          />
        </div>
        {/* <div>
          <h5>Database</h5>
          <Typeahead
            id="DatabaseFilterTypeahead"
            clearButton
            multiple
            selected={ publicationsDatabaseFilter }
            options={ metadata.database || [] }
            placeholder="Enter Database(s)"
            onChange={(databases) => this.handleChangeFilters('publicationsDatabaseFilter', databases)}
          />
        </div> */}
        <div>
          <h5>Data Source(s)</h5>
          <Typeahead
            id="DataSourcesFilterTypeahead"
            clearButton
            labelKey={(dataSource) => `${dataSource.name}`}
            multiple
            selected={publicationsDataSourcesFilter}
            options={dataSources || []}
            placeholder="Enter Data Source(s)"
            onChange={(dataSources) => this.handleChangeFilters('publicationsDataSourcesFilter', dataSources)}
          />
        </div><div>
        </div><div>
          <h5>Data Source Type(s)</h5>
          <Typeahead
            id="DataSourceTypesFilterTypeahead"
            clearButton
            labelKey={(dataSourceType) => `${dataSourceType.name}`}
            multiple
            selected={publicationsDataSourceTypesFilter}
            options={dataSourceTypes || []}
            placeholder="Enter Data Source Type(s)"
            onChange={(dataSourceTypes) => this.handleChangeFilters('publicationsDataSourceTypesFilter', dataSourceTypes)}
          />
        </div><div>
          <h5>Done With Genesis / Sirius / MAT</h5>
          <Typeahead
            id="DoneWithGenesisFilterTypeahead"
            clearButton
            multiple
            selected={ publicationsDoneWithGenesis }
            options={ ["Yes", "No"] }
            placeholder="Enter Yes/No"
            onChange={(choices) => this.handleChangeFilters('publicationsDoneWithGenesis', choices)}
          />
        </div><div>
          <h5>Regulatory Related</h5>
          <Typeahead
            id="publicationsRegulatoryRelatedTypeahead"
            clearButton
            multiple
            selected={ publicationsRegulatoryRelated }
            options={ ["Yes", "No"] }
            placeholder="Enter Yes/No"
            onChange={(choices) => this.handleChangeFilters('publicationsRegulatoryRelated', choices)}
          />
        </div>
        <hr/>
        <center>
          <ExportPublications />
        </center>
        <br/>
        <center>
          <ExportPublicationCitations />
        </center>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    // REDUX METADATA //
    publicationManagementMode: state.managePublications.publicationManagementMode,
    // DATA //
    users: state.manageLogin.users,
    genesisUsers: state.manageLogin.genesisUsers,
    currentUser: state.manageLogin.user,
    totalPublicationCount: state.managePublications.totalPublicationCount,
    filteredPublicationCount: state.managePublications.filteredPublicationCount,
    metadata: state.managePublications.metadata,
    therapeuticAreas: state.managePublications.therapeuticAreas,
    studyDesigns: state.managePublications.studyDesigns,
    dataSources: state.managePublications.dataSources,
    dataSourceTypes: state.managePublications.dataSourceTypes,
    publicationTypes: state.managePublications.publicationTypes,
    methodAnalysisTypes: state.managePublications.methodAnalysisTypes,
    // FILTERS & SORTING //
    publicationsSearchTerm: state.managePublications.publicationsSearchTerm,
    publicationsSortType: state.managePublications.publicationsSortType,
    publicationsApprovalStatusSortType: state.managePublications.publicationsApprovalStatusSortType,
    publicationsApprovalStatusFilter: state.managePublications.publicationsApprovalStatusFilter,
    publicationsAuthorFilter: state.managePublications.publicationsAuthorFilter,
    publicationsYearFilter: state.managePublications.publicationsYearFilter,
    publicationsClientFilter: state.managePublications.publicationsClientFilter,
    publicationsProductFilter: state.managePublications.publicationsProductFilter,
    publicationsIndicationFilter: state.managePublications.publicationsIndicationFilter,
    publicationsTherapeuticAreasFilter: state.managePublications.publicationsTherapeuticAreasFilter,
    publicationsStudyDesignsFilter: state.managePublications.publicationsStudyDesignsFilter,
    publicationsPublicationTypeFilter: state.managePublications.publicationsPublicationTypeFilter,
    publicationsMethodAnalysisTypesFilter: state.managePublications.publicationsMethodAnalysisTypesFilter,
    publicationsDataSourcesFilter: state.managePublications.publicationsDataSourcesFilter,
    publicationsDataSourceTypesFilter: state.managePublications.publicationsDataSourceTypesFilter,
    publicationsDoneWithGenesis: state.managePublications.publicationsDoneWithGenesis,
    publicationsRegulatoryRelated: state.managePublications.publicationsRegulatoryRelated,
  }
}


export default connect(mapStateToProps, { getPublicationsWithFilters, changePublicationsFilter, clearAllPublicationFilters, changePublicationsPage, changePublicationApprovalStatusSortType })(PublicationFilter)



// WEBPACK FOOTER //
// ./src/routes/publications/components/PublicationFilter.js